
module.exports = {
  ui: {
    fields: [
      'key', 'keyOfSellerSide', 'stafferRef', 'date', 'billDate',
      'sellerRef', 'buyerRef', 'orderType', 'summary', 'status',
    ],
  },
  populations: 'staffers,companies,suppliers',
}
